import _ from 'lodash';
import { INSTANCE_URL } from '../../Common/constant';
import {
  getRequest,
  patchRequest,
  postRequest
} from '../../Common/network-call';

// actions
import {
  fetchExhibitorDetails,
  clearExhibitorDetails
} from '../../exhibitors/actions';
import {
  fetchSponsorDetails,
  clearSponsorDetails
} from '../../sponsors/actions';

export const MY_SCAN_LIST = 'MY_SCAN_LIST';
export const SELECTED_SCAN_ITEM = 'SELECTED_SCAN_ITEM';
export const SELECTED_SCAN_LINKED_ITEM = 'SELECTED_SCAN_LINKED_ITEM';

export const fetchAppUserScanList = (session, exhibitorid = null, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND${
      exhibitorid
        ? `((userid=${session.userid})OR(exhibitorid=${exhibitorid}))`
        : `(userid=${session.userid})`
    }`
  );
  let fetchRelated = exhibitorid
    ? 'appuser_by_scanneduserid,exhibitors_by_exhibitorid'
    : 'appuser_by_scanneduserid';
  let fetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/userscans?include_count=true&related=${fetchRelated}&filter=(${filter})`;

  return dispatch => {
    // dispatch({ type: MY_SCAN_LIST, payload: {} });
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        let userArr = [],
          vCardArr = [];

        _.map(res.resource, item => {
          if (item.type == 'exhibitor') vCardArr.push(item);
          else userArr.push(item);
        });

        let dataObj = {
          users: userArr,
          vcard: vCardArr
        };

        let payloadBody = {
          count: res.meta.count,
          data: dataObj
        };
        dispatch({ type: MY_SCAN_LIST, payload: payloadBody });
        callback({ success: 1, data: payloadBody });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const exportScanListToMail = (session, callback) => {
  let postUrl = `${INSTANCE_URL}/api/v2/userqr?service=exportscans`;
  let postBody = {
    userid: session.userid,
    eventid: session.eventid
  };

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, response: res });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const selectScanItem = props => {
  if (_.isEmpty(props)) {
    return dispatch => dispatch({ type: SELECTED_SCAN_ITEM, payload: {} });
  } else {
    const { session = null, value } = props;

    let exhibitorDetails = {},
      sponsorDetails = {};
    if (_.isEmpty(value)) {
      return dispatch => {
        dispatch(clearSelectedScanItem());
        dispatch({ type: SELECTED_SCAN_ITEM, payload: value });
      };
    } else
      return dispatch => {
        dispatch(clearSelectedScanItem());
        dispatch(clearExhibitorDetails());
        dispatch(clearSponsorDetails());
        if (value.appuser_by_scanneduserid) {
          let user = value.appuser_by_scanneduserid;
          if (user.exhibitoridfk) {
            // dispatch(clearExhibitorDetails());
            dispatch(
              fetchExhibitorDetails(session, user.exhibitoridfk, exhRes => {
                if (user.sponsoridfk) {
                  // dispatch(clearSponsorDetails());
                  dispatch(
                    fetchSponsorDetails(session, user.sponsoridfk, sponRes => {
                      dispatch({
                        type: SELECTED_SCAN_ITEM,
                        payload: {
                          ...value,
                          exhibitor_by_exhibitorid: exhRes,
                          sponsor_by_sponsorid: sponRes
                        }
                      });
                    })
                  );
                } else {
                  dispatch({
                    type: SELECTED_SCAN_ITEM,
                    payload: { ...value, exhibitor_by_exhibitorid: exhRes }
                  });
                }
              })
            );
          } else {
            dispatch({
              type: SELECTED_SCAN_ITEM,
              payload: value
            });
          }
        } else {
          dispatch({ type: SELECTED_SCAN_ITEM, payload: value });
        }
      };
  }
};

export const clearSelectedScanItem = () => {
  return dispatch => dispatch({ type: SELECTED_SCAN_ITEM, payload: {} });
};

export const updateScanUserNote = (
  session,
  value,
  exhibitorid = null,
  callback
) => {
  let patchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/userscans`,
    patchBody = value;

  let updateItemId = value.resource[0].id;

  return dispatch => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      response => {
        dispatch(
          fetchAppUserScanList(session, exhibitorid, res => {
            if (res.success) {
              let users = res.data.data.users;
              let vcard = res.data.data.vcard;

              let userFilterArr = _.filter(
                  users,
                  item => item.id == updateItemId
                ),
                vcardFilterArr = [];
              if (userFilterArr.length > 0) {
                dispatch(selectScanItem({ session, value: userFilterArr[0] }));
                callback({
                  success: 3,
                  patch: true,
                  fetch: true,
                  select: true
                });
              } else {
                vcardFilterArr = _.filter(
                  vcard,
                  item => item.id == updateItemId
                );
                if (vcardFilterArr.length > 0) {
                  dispatch(
                    selectScanItem({ session, value: vcardFilterArr[0] })
                  );
                  callback({
                    success: 3,
                    patch: true,
                    fetch: true,
                    select: true
                  });
                } else {
                  callback({
                    success: 2,
                    patch: true,
                    fetch: true,
                    select: false
                  });
                }
              }
              // callback({ success: 2, patch: true, fetch: true, select: false });
            } else callback({ success: 1, patch: true, fetch: false });
          })
        );
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const setSelectedScanLinkedItem = value => {
  return dispatch => {
    dispatch(clearSelectedScanLinkedItem());
    dispatch({ type: SELECTED_SCAN_LINKED_ITEM, payload: value });
  };
};

export const clearSelectedScanLinkedItem = () => {
  return dispatch => {
    dispatch({ type: SELECTED_SCAN_LINKED_ITEM, payload: {} });
  };
};

export const fetchExportScanCSVData = (session, values, callback) => {
  let postUrl = `${INSTANCE_URL}/api/v2/userqr`;

  return dispatch => {
    postRequest(
      postUrl,
      values,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res?.resource, message: null });
      },
      error => {
        callback({ success: 0, data: null, message: error });
      }
    );
  };
};
